import { APP_SERVICE, AppService } from "@cervval.js/common/services";
import { injector } from "@cervval.js/common/src/dependencies/injector";
import { PropertyConfig } from "@cervval.js/common/src/forms/propertyConfig";
import { PropertyConfigType } from "@cervval.js/common/src/forms/propertyConfig.types";
import { PhoneNumberValidator } from "@cervval.js/common/src/services/validation.impl/validators/phoneNumber.validator";
import { RequiredValidator } from "@cervval.js/common/src/services/validation.impl/validators/required.validator";
import { validatorEntry } from "@cervval.js/common/src/services/validation.impl/validators/validator";
import { BookingUser } from "../booking.dto";
import { I18nProfileBooking } from "./profileBooking.i18n";

export const sortedPhoneNumberDTOKeys: (keyof BookingUser)[] = ["phoneNumber"];

/** Export BookingUser as PropertyConfig */
export function exportBookingPhoneNumberDTOToPropertyConfig(): PropertyConfig[] {
    const i18n = I18nProfileBooking();
    const phoneLocale = injector.find<AppService>(APP_SERVICE)?.getLocale().phoneLocale ?? "FR";
    const propertyConfigs: PropertyConfig[] = [];
    sortedPhoneNumberDTOKeys.forEach((key) => {
        let propertyConfig = {} as PropertyConfig;
        const comp = propertyConfig;
        switch (key) {
            case "phoneNumber":
                propertyConfig = {
                    label: i18n.phoneNumber.label,
                    propertyName: key,
                    typeUid: PropertyConfigType.PHONE_NUMBER,
                    validators: {
                        ...validatorEntry(RequiredValidator, true),
                        ...validatorEntry(PhoneNumberValidator, phoneLocale)
                    }
                };
                break;
            default:
                break;
        }
        if (propertyConfig !== comp) {
            propertyConfigs.push(propertyConfig);
        }
    });
    return propertyConfigs;
}